import React from "react";
import MainContainer from "../../components/container/MainContainer";

const FinancialStatement = () => {
  const data = {
    income: [
      { title: "Lump Sum Grant", 2021: 4795388.32, 2020: 6185697.73 },
      {
        title: "Lump Sum Grant (excluding Provident Fund)",
        2021: "-",
        2020: "-",
      },
      { title: "Provident Fund", 2021: "-", 2020: "-" },
      { title: "Special One-off Grant", 2021: "-", 2020: "-" },
      { title: "Fee Income", 2021: "-", 2020: "-" },
      { title: "Other Income", 2021: "-", 2020: "-" },
      { title: "Interest Received", 2021: "-", 2020: "-" },
    ],
    totalIncome: { 2021: 4795388.32, 2020: 6185697.73 },
    expenditure: [
      {
        title: "Formation/ Pastoral Work/ Social Care",
        2021: 764395.2,
        2020: 1230487.0,
      },
      { title: "TVET/ Education", 2021: 1166481.198, 2020: 1117866.94 },
      { title: "Rural Development", 2021: 1006641.173, 2020: 1959508.78 },
      {
        title: "Agriculture and Youth Development",
        2021: 977642.66,
        2020: 522454.74,
      },
      { title: "Administrative Cost", 2021: 111465.07, 2020: 92806.0 },
    ],
    totalExpenditure: { 2021: 4026626.63, 2020: 4923123.46 },
    surplus: { 2021: 768761.69, 2020: 1262574.27 },
  };

  return (
    <MainContainer>
      <div className="financial-report">
        <h4>STATEMENT OF FINANCIAL POSITION AS AT 31ST DECEMBER </h4>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>NOTES</th>
                <th>2021 (EUR)</th>
                <th>2020 (EUR)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th colSpan="3">A. INCOME</th>
              </tr>
              {data.income.map((item, index) => (
                <tr key={index}>
                  <td>{item.title}</td>
                  <td>{item[2021]}</td>
                  <td>{item[2020]}</td>
                </tr>
              ))}
              <tr>
                <td>
                  <strong>TOTAL INCOME</strong>
                </td>
                <td>
                  <strong>{data.totalIncome[2021]}</strong>
                </td>
                <td>
                  <strong>{data.totalIncome[2020]}</strong>
                </td>
              </tr>
              <tr>
                <th colSpan="3">B. EXPENDITURE</th>
              </tr>
              {data.expenditure.map((item, index) => (
                <tr key={index}>
                  <td>{item.title}</td>
                  <td>{item[2021]}</td>
                  <td>{item[2020]}</td>
                </tr>
              ))}
              <tr>
                <td>
                  <strong>TOTAL EXPENDITURE</strong>
                </td>
                <td>
                  <strong>{data.totalExpenditure[2021]}</strong>
                </td>
                <td>
                  <strong>{data.totalExpenditure[2020]}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>SURPLUS / (DEFICIT)</strong>
                </td>
                <td>
                  <strong>{data.surplus[2021]}</strong>
                </td>
                <td>
                  <strong>{data.surplus[2020]}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* <p>
          <strong>Basis of preparation Annual Financial Report (AFR):</strong>{" "}
          The Annual Financial Report (AFR) is prepared on cash basis, meaning
          that income is recognized upon receipt of cash and expenditure is
          recognized when expenses are paid. Non-cash items like depreciation,
          provisions, and accruals are not included in the AFR.
        </p> */}
      </div>
    </MainContainer>
  );
};

export default FinancialStatement;
